import { ssoStatusResponseSchema, type SsoStatus } from "@repo/shared";

import { API_V1_PREFIX, apiRequestJson } from "../api-client";

/** Login H2J (#700): public, so it also works on the sign-in screen. */
export async function getSsoStatus(): Promise<SsoStatus> {
  const response = await apiRequestJson({
    path: `${API_V1_PREFIX}/sso`,
    responseSchema: ssoStatusResponseSchema,
    badResponseMessage: "Unexpected response when loading the sign-in options",
  });
  return response.data;
}
